import { Link } from "react-router-dom";
import { MapPin, Phone, MessageCircle } from "lucide-react";
import { NAV_LINKS } from "../../data/site";
import { scrollToId, waLink, PHONE_TEL, PHONE_DISPLAY, ADDRESS } from "../../lib/contact";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#070C16] border-t border-white/5 pt-16 pb-28 md:pb-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center">
            <img src="/logo-full.png" alt="LaunchX Academy" className="h-10 w-auto" data-testid="footer-logo" />
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">Practical Online Business Academy</p>
          <p className="mt-2 text-xs font-bold tracking-[0.3em] text-cyanx uppercase">Learn. Launch. Grow.</p>
          <p className="mt-6 flex items-start gap-2 text-sm text-slate-500">
            <MapPin size={15} className="mt-0.5 shrink-0 text-electric" />
            {ADDRESS}
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-slate-500">Explore</p>
          <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
            {NAV_LINKS.map((l) => (
              <button key={l.id} data-testid={`footer-link-${l.id}`} onClick={() => scrollToId(l.id)} className="text-left text-sm text-slate-400 hover:text-cyanx transition-colors">
                {l.label}
              </button>
            ))}
            <Link to="/scholarship" data-testid="footer-link-scholarship" className="text-sm text-cyanx font-semibold hover:text-white transition-colors">Scholarship Test 2026</Link>
            <Link to="/privacy-policy" data-testid="footer-link-privacy" className="text-sm text-slate-400 hover:text-cyanx transition-colors">Privacy Policy</Link>
            <Link to="/terms-and-conditions" data-testid="footer-link-terms" className="text-sm text-slate-400 hover:text-cyanx transition-colors">Terms &amp; Conditions</Link>
          </div>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-slate-500">Admissions</p>
          <div className="mt-5 space-y-3">
            <a data-testid="footer-whatsapp" href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 text-sm text-slate-400 hover:text-cyanx transition-colors">
              <MessageCircle size={15} className="text-electric" /> WhatsApp: {PHONE_DISPLAY}
            </a>
            <a data-testid="footer-phone" href={`tel:${PHONE_TEL}`} className="flex items-center gap-2.5 text-sm text-slate-400 hover:text-cyanx transition-colors">
              <Phone size={15} className="text-electric" /> {PHONE_DISPLAY}
            </a>
            <button
              data-testid="footer-book-counselling"
              onClick={() => scrollToId("contact")}
              className="mt-2 inline-flex items-center gap-2 bg-electric hover:bg-electric-dark text-white font-semibold text-sm rounded-full px-6 py-3 transition-colors"
            >
              Book Free Counselling
            </button>
          </div>
        </div>
      </div>
      <div className="mt-14 pt-7 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-xs text-slate-600">© {new Date().getFullYear()} LaunchX Academy, Rampur, Uttar Pradesh. All rights reserved.</p>
        <p className="text-xs text-slate-600 max-w-xl">
          LaunchX provides practical education, tools, frameworks and guided projects. Business results, employment and income depend on many factors and are never guaranteed.
        </p>
      </div>
    </div>
  </footer>
);
